import React, { useMemo } from 'react';

import { View } from 'react-native';

import { ContentType } from 'services/data-manager/types';

import {
    RibbonTouchableType,
    collectionContainerDimensions,
    metadataTypeToRibbonType,
    stripeContainerDimensions,
} from 'components/CustomButtons/RibbonTouchable/styles';

import styles, { progressBarMargin } from './styles';

type Props = {
    position: number | undefined;
    duration: number | undefined;
    contentType?: ContentType;
    isCollection?: boolean;
    backgroundColor?: string;
};

function StaticProgressBar({
    position,
    duration,
    contentType,
    isCollection,
    backgroundColor,
}: Props) {
    const progress = useMemo(() => {
        const ribbonType =
            (contentType && metadataTypeToRibbonType[contentType]) ||
            RibbonTouchableType.LANDSCAPE;
        const ribbonStyle = isCollection
            ? collectionContainerDimensions[ribbonType]
            : stripeContainerDimensions[ribbonType];
        const width =
            typeof ribbonStyle?.width === 'number'
                ? ribbonStyle?.width - progressBarMargin * 2
                : undefined;

        return width != null && position != null && duration != null
            ? (width * position) / duration
            : 0;
    }, [position, duration, contentType, isCollection]);

    if (!progress) {
        return null;
    }

    return (
        <View style={styles.root}>
            <View style={styles.container}>
                <View
                    style={[
                        styles.progress,
                        {
                            backgroundColor,
                            width: progress,
                        },
                    ]}
                />
            </View>
        </View>
    );
}

export default StaticProgressBar;
